import React from 'react';
import { IconFile } from '../../icons';
import { IProposta } from '../../../utility/IProposta';
import {
  Container,
  TitleSection,
  TitleIcon,
  TitleText,
  Label,
  Value,
  Divider
} from './styles';
import { comum } from "../../../styles/Themes/light";
import { ContentSection, SectionColumn } from '../styles';

interface DadosClienteProcessoCardDemandaProps {
  proposta: IProposta;
  showDivider?: boolean;
}

export default function DadosClienteProcessoCardDemanda({ proposta, showDivider = false }: DadosClienteProcessoCardDemandaProps) {
  return (
    <Container>
      <TitleSection>
        <TitleIcon>
          <IconFile color={comum.colors.interfaceGray300}/>
        </TitleIcon>
        <TitleText>DADOS DO CLIENTE E PROCESSO</TitleText>
      </TitleSection>
      
      <ContentSection>
        <SectionColumn>
          <Label>CLIENTE</Label>
          <Value>{proposta.nome_cliente || 'N/A'}</Value>
        </SectionColumn>
        
        <SectionColumn>
          <Label>PROCESSO</Label>
          <Value>{proposta.numero_processo}</Value>
        </SectionColumn>
        <SectionColumn>
          <Label>COMARCA</Label>
          <Value>{proposta.uf_comarca} - {proposta.cidade_comarca}</Value>
        </SectionColumn>
      </ContentSection>
      {showDivider && <Divider />}
    </Container>
  );
} 